<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GG2K4x/tc-custom/9783988269911.jpg?1704453546080" alt="This image is the cover for the book Cab and Caboose, The Story of a Railroad Boy, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cab and Caboose, The Story of a Railroad Boy, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>‘Cab &amp; Caboose’ is a journey through the young life of one Rodman Ray Blake, railroad dreamer. Written in a style akin to ‘Huckleberry Finn’, it follows Rodman’s meteoric rise through the ranks of railroad men. It is a tale full of adventures, derring-do, heroism, and passion for the railroad's mystique that must have evoked a genuine thrill in the hearts and minds of the young men and women who first read its pages more than a century ago. The numerous re-printings it experienced, over a great many years, seems only to prove this out. While a bit dated in some respects, it still offers young readers a glimpse of what life was like at the turn of the last century. Further, it also serves to prove that - no matter what era we live in – the problems faced through adolescence never seem to fundamentally change. In this, then, it offers an enduring connection to the modern day.(amazon)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kirk Munroe
      </h2>
      
      <p class="authorDescription body article">Kirk Munroe (1850-1930) was an American author and journalist, best known for his adventure novels and stories for young readers. His works often featured tales of exploration, adventure, and outdoor life, making him a popular writer of juvenile fiction during the late 19th and early 20th centuries. Kirk Munroe's novels for young readers and his love for adventure and exploration continue to be appreciated for their ability to inspire a sense of wonder and adventure in readers, especially among young audiences.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?45653ee4